import { render } from "./TranslationChecker.vue?vue&type=template&id=5f7523c6"
import script from "./TranslationChecker.vue?vue&type=script&lang=js"
export * from "./TranslationChecker.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__